import React, { useState } from 'react';
import Skeleton from '@mui/lab/Skeleton';
import './ImageLoader.scss';

export default function ImageLoader({ loadImage, imageAlt, type = 'rect', height = 175, width = null }) {
    const [imageLoaded, setImageLoaded] = useState(false);

    return (
        <span className='image-loader' style={{ width: width === null || isNaN(width) ? '100%' : width + 'px' }}>
            <img
                className={`image-main ${imageLoaded ? 'visible' : 'not-visible'}`}
                src={loadImage}
                onLoad={() => {
                    setImageLoaded(true);
                }}
                alt={imageAlt}
                style={{ maxHeight: height, minHeight: height }}
            />
            <Skeleton
                className={`${!imageLoaded ? 'visible' : 'not-visible'} image-loading`}
                variant={type}
                height={height}
                width={isNaN(width) ? '100%' : width}
            />
        </span>
    );
}
